'use client';

/**
 * Do not edit this file manually.
 * It is automatically generated.
 * Run `npm run svg:convert` to regenerate.
 */
import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { SxProps } from '@mui/material/styles';
import BookIcon from './BookIcon';
import BrandAwarenessIcon from './BrandAwarenessIcon';
import CableIcon from './CableIcon';
import CampaignIcon from './CampaignIcon';
import CategoryIcon from './CategoryIcon';
import ChatIcon from './ChatIcon';
import CirclesExtIcon from './CirclesExtIcon';
import ContactIcon from './ContactIcon';
import CorporateFareIcon from './CorporateFareIcon';
import DockToRightIcon from './DockToRightIcon';
import DownloadIcon from './DownloadIcon';
import EventUpcomingIcon from './EventUpcomingIcon';
import FaqIcon from './FaqIcon';
import FaqLargeIcon from './FaqLargeIcon';
import FileIcon from './FileIcon';
import FrameInspectIcon from './FrameInspectIcon';
import GoogleIcon from './GoogleIcon';
import HomeIcon from './HomeIcon';
import InventoryIcon from './InventoryIcon';
import LabProfileIcon from './LabProfileIcon';
import LightIcon from './LightIcon';
import LogoutIcon from './LogoutIcon';
import ManageSearchIcon from './ManageSearchIcon';
import MountainIcon from './MountainIcon';
import QuestionRoundIcon from './QuestionRoundIcon';
import QuickIcon from './QuickIcon';
import SavedSearchIcon from './SavedSearchIcon';
import ShoppingCartIcon from './ShoppingCartIcon';
import SparklesIcon from './SparklesIcon';
import SpeedIcon from './SpeedIcon';
import StorefrontIcon from './StorefrontIcon';
import WandIcon from './WandIcon';
const icons = {
  Book: BookIcon,
  BrandAwareness: BrandAwarenessIcon,
  Cable: CableIcon,
  Campaign: CampaignIcon,
  Category: CategoryIcon,
  Chat: ChatIcon,
  CirclesExt: CirclesExtIcon,
  Contact: ContactIcon,
  CorporateFare: CorporateFareIcon,
  DockToRight: DockToRightIcon,
  Download: DownloadIcon,
  EventUpcoming: EventUpcomingIcon,
  Faq: FaqIcon,
  FaqLarge: FaqLargeIcon,
  File: FileIcon,
  FrameInspect: FrameInspectIcon,
  Google: GoogleIcon,
  Home: HomeIcon,
  Inventory: InventoryIcon,
  LabProfile: LabProfileIcon,
  Light: LightIcon,
  Logout: LogoutIcon,
  ManageSearch: ManageSearchIcon,
  Mountain: MountainIcon,
  QuestionRound: QuestionRoundIcon,
  Quick: QuickIcon,
  SavedSearch: SavedSearchIcon,
  ShoppingCart: ShoppingCartIcon,
  Sparkles: SparklesIcon,
  Speed: SpeedIcon,
  Storefront: StorefrontIcon,
  Wand: WandIcon
};
interface IconProps {
  icon: string;
  size?: number;
  color?: string;
  sx?: SxProps;
}
const Icon = t0 => {
  const $ = _c(11);
  const {
    icon,
    size: t1,
    color,
    sx: t2
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const sx = t3;
  const Icon = icons[icon as keyof typeof icons];
  if (!Icon) {
    console.warn("Icon not found.", icon);
    return null;
  }
  let t4;
  if ($[2] !== color) {
    t4 = color ? {
      color
    } : {};
    $[2] = color;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== sx || $[5] !== t4) {
    t5 = {
      ...sx,
      ...t4
    };
    $[4] = sx;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== Icon || $[8] !== size || $[9] !== t5) {
    t6 = <Icon width={size} height={size} sx={t5} />;
    $[7] = Icon;
    $[8] = size;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default Icon;
export type { IconProps };